import { IDineInBill, LINE_STATUS_META, normalizeLineStatus } from "../models/IDineIn";

export function money(n: number, symbol?: string): string {
  return `${n.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}${symbol ? ` ${symbol}` : ""}`;
}

export function formatDateTime(iso?: string): string {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("tr-TR", {
    day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
  });
}

export const HISTORY_STATUS_META: Record<string, { label: string; cls: string }> = {
  Open:      { label: "Açık",       cls: "dinein-badge--open" },
  Paid:      { label: "Ödendi",     cls: "dinein-badge--paid" },
  Cancelled: { label: "Boşaltıldı", cls: "dinein-badge--cancelled" },
};

interface Props {
  item: IDineInBill;
  expanded: boolean;
  onToggle: () => void;
  /** Bütün salon listesinde hangi masa olduğu da yazılır */
  showTable?: boolean;
}

/** Geçmişteki tek oturum: başlık (durum, tutar, zaman, personel) + açılınca satırlar. */
export default function HistoryBillItem({ item, expanded, onToggle, showTable }: Props) {
  const s = item.session;
  const meta = HISTORY_STATUS_META[String(s.status)] ?? { label: String(s.status), cls: "" };
  const cur = s.currencyDisplayText;

  return (
    <div className="dinein-history-item">
      <button type="button" className="dinein-history-item__head" onClick={onToggle}>
        <div>
          <div className="dinein-history-item__title">
            {showTable && (
              <span className="dinein-badge" style={{ background: "#eef2ff", color: "#4338ca" }}>
                Masa {s.tableNumber}{s.tableLabel ? ` · ${s.tableLabel}` : ""}
              </span>
            )}
            <span className={`dinein-badge ${meta.cls}`}>{meta.label}</span>
            <strong>{money(s.status === "Cancelled" ? 0 : item.totalAmount, cur)}</strong>
            {s.paymentMethodNameTr && (
              <span className="dinein-badge" style={{ background: "#f1f5f9", color: "#334155" }}>
                <i className={`bi ${/kart|card/i.test(s.paymentMethodNameTr) ? "bi-credit-card-2-front" : "bi-cash-stack"} me-1`}></i>
                {s.paymentMethodNameTr}
              </span>
            )}
            <span className="dinein-muted">{item.lines.length} satır</span>
          </div>
          <div className="dinein-muted dinein-small">
            {formatDateTime(s.openedAtUtc)}
            {s.closedAtUtc && <> → {formatDateTime(s.closedAtUtc)}</>}
            {s.openedByUserName && <> · açan: {s.openedByUserName}</>}
            {s.closedByUserName && <> · kapatan: {s.closedByUserName}</>}
          </div>
        </div>
        <i className={`bi bi-chevron-${expanded ? "up" : "down"}`}></i>
      </button>

      {expanded && (
        <div className="dinein-history-item__body">
          {item.lines.length === 0 ? (
            <div className="dinein-muted dinein-small">Bu oturumda satır yok.</div>
          ) : (
            item.lines.map((l) => {
              const st = LINE_STATUS_META[normalizeLineStatus(l.status)];
              return (
                <div key={l.lineId} className="dinein-history-line" style={{ alignItems: "center", gap: 8 }}>
                  <span style={{ flex: 1, minWidth: 0 }}>{l.quantity}× {l.foodNameTr}{l.foodOrderNote ? ` — ${l.foodOrderNote}` : ""}</span>
                  <span className={`dinein-status ${st.cls}`} style={{ animation: "none" }}>
                    <i className={`bi ${st.icon}`}></i>{st.label}
                  </span>
                  <span>{money(l.lineTotal, cur)}</span>
                </div>
              );
            })
          )}
          {item.totalDiscountAmount > 0 && (
            <div className="dinein-history-line dinein-muted">
              <span>Kampanya indirimi</span>
              <span>−{money(item.totalDiscountAmount, cur)}</span>
            </div>
          )}
          <div className="dinein-history-line dinein-history-line--total">
            <span>Toplam</span>
            <span>{money(item.totalAmount, cur)}</span>
          </div>
          <div className="dinein-muted dinein-small" style={{ marginTop: 6 }}>
            Sipariş kodu: <code>{s.orderCode}</code>
          </div>
        </div>
      )}
    </div>
  );
}
